export const baseUrl = process.env.REACT_APP_API_URL || 'http://urlfortests';
